import { Activity, Bell, Building2, CreditCard, RefreshCw, Server, ShieldCheck, ShoppingCart, UserPlus, WalletCards, type LucideIcon } from 'lucide-react';
import { VaniaGlassPanel } from '@vanialabs/ui-engine';
import type { MonitoringSnapshot } from '../../monitoring/types/monitoring.types';

interface ControlPlaneActivityProps {
  monitoring: MonitoringSnapshot | null;
}

function activityVisual(title: string): { Icon: LucideIcon; tone: string } {
  const normalized = title.toLowerCase();
  if (normalized.includes('payment') || normalized.includes('پرداخت') || normalized.includes('revenue') || normalized.includes('درآمد') || normalized.includes('wallet')) return { Icon: WalletCards, tone: 'is-payment' };
  if (normalized.includes('order') || normalized.includes('سفارش')) return { Icon: ShoppingCart, tone: 'is-order' };
  if (normalized.includes('security') || normalized.includes('امنیت') || normalized.includes('auth') || normalized.includes('ورود')) return { Icon: ShieldCheck, tone: 'is-security' };
  if (normalized.includes('update') || normalized.includes('به‌روزرسانی') || normalized.includes('system') || normalized.includes('سیستم')) return { Icon: RefreshCw, tone: 'is-system' };
  if (normalized.includes('tenant') || normalized.includes('تننت')) return { Icon: Building2, tone: 'is-tenant' };
  if (normalized.includes('service') || normalized.includes('سرویس')) return { Icon: Server, tone: 'is-service' };
  if (normalized.includes('user') || normalized.includes('کاربر') || normalized.includes('register') || normalized.includes('ثبت')) return { Icon: UserPlus, tone: 'is-user' };
  return { Icon: Bell, tone: 'is-neutral' };
}

function formatEventDate(value?: string) {
  if (!value) return 'زمان نامشخص';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString('fa-IR');
}

export function ControlPlaneActivity({ monitoring }: ControlPlaneActivityProps) {
  const events = monitoring?.recent_events ?? [];

  return <VaniaGlassPanel className="vania-control-plane-activity">
    <div className="vania-control-plane-section-heading"><div><span>Activity Stream</span><h2>فعالیت‌های اخیر</h2></div><Activity size={18} aria-hidden="true" /></div>
    {events.length > 0 ? <ul>{events.slice(0, 5).map((event, index) => { const { Icon, tone } = activityVisual(event.title); return <li key={`${event.title}-${event.created_at ?? index}`}><span className={`vania-control-plane-activity-icon ${tone}`}><Icon size={15} /></span><span><strong>{event.title}</strong><small>{formatEventDate(event.created_at)}</small></span></li>; })}</ul> : <p className="vania-control-plane-empty">رویداد اخیری از API دریافت نشده است.</p>}
  </VaniaGlassPanel>;
}
